import { useState, useEffect, useCallback } from "react";
import { useApi } from "./use-api";
import { toDate } from "@/lib/dates";
export function useConversation(ticketId, updatedAt) {
    const [messages, setMessages] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const { callApi } = useApi();
    const fetchMessages = useCallback(async () => {
        if (!ticketId) {
            setLoading(false);
            return;
        }
        try {
            setLoading(true);
            setError(null);
            const result = await callApi("conversation.getMessages", { ticketId });
            const rawMessages = result?.messages ?? [];
            const parsed = rawMessages.map((msg) => ({
                ...msg,
                createdAt: toDate(msg.createdAt),
            }));
            setMessages(parsed);
        }
        catch (err) {
            const message = err instanceof Error ? err.message : "Failed to load messages";
            setError(message);
            console.error("Failed to fetch messages:", err);
        }
        finally {
            setLoading(false);
        }
    }, [ticketId, callApi]);
    useEffect(() => {
        fetchMessages();
    }, [fetchMessages, updatedAt]);
    return { messages, loading, error, refetch: fetchMessages };
}
